// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xa-1";
export var printerIcon = "_xa-0";